<template>
  <div class="flex flex-nowrap items-center justify-center gap-x-1">
    <slot></slot>
  </div>
</template>
<script setup></script>
